<template>
  <div class="light-theme c-fluid" id="about">
    <div class="row">
      <div class="col-sm-12 col-lg-8 px-0 row">
        <div class="col-3 title-line yellow my-auto"></div>
        <div class="col-4 title-text my-auto text-center">O U R &nbsp; S T O R Y</div>
        <div class="col-5 title-line yellow my-auto"></div>
      </div>
    </div>
    <div class="section-content text-justify">
      <p>{{body.first}}</p>

      <p v-for="(timeline,ind) in body.second" :key="'T' +ind">
        In
        <strong class="year strong">{{timeline.year}},</strong>
        {{timeline.text}}
        <i class="fw-6" v-if="timeline.sub">"{{timeline.sub}}"</i>
      </p>

      <div class="text-center">
        <div class="d-inline-block mx-2 text-center">
          <img src="/static/imgs/event-15.jpg" class="event-img" />
          <p
            class="img-text"
          >Some team members at the Heart of Delta Orphanage, Delta State Nigeria (2015)</p>
        </div>
        <div class="d-inline-block mx-2 text-center">
          <img src="/static/imgs/event-16.jpeg" class="event-img" />
          <p
            class="img-text"
          >A cross section of some speakers and attendants during a Community/Welfare event (2016)</p>
        </div>
      </div>

      <div class="mt-5" v-for="(f, index) in body.others" :key="index">
        <p>
          <span v-if="f.istitleProject" class="fw-6 title pb-2">H O W &nbsp; W E &nbsp; W O R K</span>
          <span v-if="f.title" class="fw-6 title pb-2">O U R &nbsp; {{f.title}}</span>
          <span
            v-if="f.istitleMandateAndFocus"
            class="fw-6 title pb-2"
          >O U R &nbsp; M A N D A T E &nbsp; A N D &nbsp; F O C U S</span>
        </p>
        <p :class="f.istitleProject ? 'pt-3' : 'py-3'" v-if="f.text">{{f.text}}</p>
        <ul class="py-3" v-if="f.isList">
          <li v-for="(l, index) in f.list" :key="index">{{l}}</li>
        </ul>
        <p v-if="f.isEvent">
          One major project is the
          <strong class="strong">“Stop the abuse of Deaf Girls”</strong>
          with the brand name
          <strong class="strong">Beauty Beyond Speech</strong> (BBS). It is advocating for safety of deaf girls as part of their
          contribution to the campaign against Violence against Women (VAW).
        </p>

        <p class="pb-3" v-if="f.text2">{{f.text2}}</p>

        <p v-if="f.istitleProject && f.moreInfo">
          <strong class="strong">
            For more information on projects or parnterships please
            <span
              class="pointer contact strong"
              @click="scrollToContact()"
            >contact us</span>
          </strong>
        </p>
      </div>

      <p class="mt-5">
        <span class="fw-6 title">O U R &nbsp; E V E N T &nbsp; I N &nbsp; P I C T U R E S</span>
      </p>

      <div id="slideIndicator" class="carousel slide mx-auto" data-ride="carousel">
        <ol class="carousel-indicators">
          <li
            data-target="#slideIndicator"
            v-for="(s, i) of 12"
            :key="s"
            :data-slide-to="i"
            :class="{'active': i == 0}"
          ></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item" v-for="s of 12" :key="s" :class="{'active': s == 1}">
            <img
              class="d-block w-100"
              :src="'/static/imgs/slideshow/' + s + '.jpg'"
              :alt="'Slide' + s"
            />
          </div>
        </div>

        <a class="carousel-control-prev" href="#slideIndicator" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#slideIndicator" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {};
  },
  props: {
    body: {
      type: Object,
      required: true
    }
  },
  methods: {
    scrollToContact() {
      $("html, body").animate(
        {
          scrollTop: $("#contact").offset().top
        },
        0
      );
    }
  },
  mounted: function() {
    $(".carousel").carousel({
      interval: 2000
    });
  }
};
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .light-theme {
    padding: 40px 10px;
  }
}

@media screen and (min-width: 801px) {
  .light-theme {
    padding: 90px;
  }
}

.section-content {
  margin: 2rem 0;
}
@media screen and (min-width: 1050px) {
  .carousel {
    width: 80%;
  }
}
@media screen and (max-width: 700px) {
  .event-img {
    width: 300px;
  }
}

@media screen and (min-width: 701px) {
  .event-img {
    width: 450px;
  }
}
.event-img {
  margin: 1.5rem;
  border-radius: 20px;
}
.img-text {
  font-size: 0.8rem;
}
.title {
  border-bottom: 1px solid;
}
.year {
  font-size: 1.2rem;
}
@media screen and (min-width: 1050px) {
  .carousel {
    width: 60% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue